import { IconSVG } from '../types';

export const CameraOff = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="m22 19.125-2-2V7h-4.05l-1.825-2h-4.25l-.95 1.05L7.5 4.625 9 3h6l1.85 2H20q.824 0 1.413.587Q22 6.175 22 7zM4 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 19V7q0-.824.587-1.413A1.93 1.93 0 0 1 4 5h1.025l2 2H4v12h15.025l2 2zm11.65-5.375a4.7 4.7 0 0 1-1.562 1.363A4.3 4.3 0 0 1 12 17.5q-1.875 0-3.188-1.312Q7.5 14.875 7.5 13q0-1.15.512-2.088A4.7 4.7 0 0 1 9.375 9.35l1.45 1.45q-.6.325-.963.9A2.4 2.4 0 0 0 9.5 13q0 1.05.725 1.775T12 15.5q.725 0 1.3-.363.574-.362.9-.962zM15.2 9.8q.625.6.963 1.425T16.5 13v.3q0 .15-.025.3L11.4 8.525q.15-.025.3-.025h.3q.95 0 1.775.337T15.2 9.8m5.275 13.5L.675 3.5 2.1 2.075l19.8 19.8z"
      />
    </svg>
  );
};
